import SavedSearchSubscriptionsListContainerReducer from './SavedSearchSubscriptionsListContainerReducer';

export * as actions from './SavedSearchSubscriptionsListContainerActions';
export const SavedSearchSubscriptionsListContainerReducers = {
  SavedSearchSubscriptionsListContainerReducer,
};
